const selector = "#ProductGridContainer";
let cacheManager = {};

window.addEventListener('pageshow', function(e){
  console.log(`Persisted: ${e.persisted}`);
  onLoad(e);
});

function onLoad(e){
  cacheManager = new PageCacheManager(
    { 
      bodySelector: selector,
      onLoaded: onLoadedCache,
      onCached: onCachedCache,
    }
  );
  
  if (!e.persisted) {
    document.addEventListener('click', function (e) {
      const closest1 = e.target.closest('.product-grid .card-wrapper a');
      const closest2 = e.target.closest('.product-list__content__container a');
      
      if (closest1 || closest2) cacheManager.cachePage();
    });    
  }
}

function infiniteScrollCollection() {
  var endlessScroll = new Ajaxinate({
    container: '#ProductGridContainer .product-grid',
    pagination: '#AjaxinatePagination',
    method: 'scroll',
    loadingText: '',
    offset: 1000
  });
}

function onLoadedCache(e){
  console.log('loaded');
  infiniteScrollCollection();
  //document.querySelector(selector).style.visibility = 'visible';
};

function onCachedCache(e){
  console.log('cached');
  //document.querySelector(selector).style.visibility = 'hidden';
};